import React from 'react';
import validate from 'validate.js';
import { FormattedMessage } from 'react-intl';

const validateAccessForm = ({
  equipment_loading_description = '',
  has_separate_crew_area,
  separate_crew_area_description = '',
  has_off_limit_areas,
  off_limit_areas_description = ''
}) => {
  const validations = {};

  const description = <FormattedMessage id="hosting.validate_access_form.description_error_message" defaultMessage="Please enter a description" />;

  if ('' !== equipment_loading_description) {
    Object.assign(validations, {
      equipment_loading_description: validate.single(equipment_loading_description,
        {
          length: {
            minimum: 15,
            tooShort: <FormattedMessage id="hosting.validate_access_form.equipment_min_char_error_message" defaultMessage="Enter at least 15 characters"/>
          }
        })
    });
  }

  if (has_separate_crew_area && separate_crew_area_description) {
    Object.assign(validations, {
      separate_crew_area_description: validate.single(separate_crew_area_description,
        {
          length: {
            minimum: 3,
            tooShort: <FormattedMessage id="hosting.validate_access_form.crew_min_char_error_message" defaultMessage="Enter at least 3 characters"/>
          }
        })
    });
  }

  if (has_off_limit_areas) {
    Object.assign(validations, {
      off_limit_areas_description: validate.single(off_limit_areas_description,
        {
          presence: {
            allowEmpty: false,
            message: description
          },
          length: {
            minimum: 3,
            tooShort: <FormattedMessage id="hosting.validate_access_form.crew_min_char_error_message" defaultMessage="Enter at least 3 characters"/>
          }
        })
    });
  }

  return validations;
};

export default validateAccessForm;
